module.exports = __webpack_public_path__ + "assets/minus.3a938a7d.svg";